import { lazy } from "react";
import Loadable from "app/components/Loadable";

const OsList = Loadable(lazy(() => import("./OsList")));
const OsAdd = Loadable(lazy(() => import("./OsAdd")));

const OsRoutes = [
  { path: "/asset/os", element: <OsList /> },
  { path: "/asset/os/:mode/:id", element: <OsAdd /> },
];

export default OsRoutes;
